import { Injectable } from '@angular/core';
import {BaseDataService} from '../../../core/services/base-data.service';
import {API_MAP} from '../../../core/helpers/api.map';
import {Observable, tap} from 'rxjs';
import {Result} from '../../../core/models/result';
import {About} from '../models/about.model';

@Injectable()
export class AboutService extends BaseDataService<About>{
  override controller = API_MAP.locations;

  override get(controller?: string): Observable<Result<any>> {
    return super.get(controller ?? this.controller).pipe(
      tap((d: any) => {
        this.content.set(d.content);
        this.components.set(d.components);
      })
    );
  }
}
